{
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.primary": [
    {
      "type": 0,
      "value": "Try Rovo now"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.secondary": [
    {
      "type": 0,
      "value": "Try Rovo now"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.subtitle": [
    {
      "type": 0,
      "value": "Jump into Confluence to discover what's possible."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.title": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.description": [
    {
      "type": 0,
      "value": "Prompt Rovo to start creating for you. Use anything across Confluence as input."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.title": [
    {
      "type": 0,
      "value": "Create any content with Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.description": [
    {
      "type": 0,
      "value": "Utilize Rovo in any doc or page by highlighting any text. Edit your writing or start drafting."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.title": [
    {
      "type": 0,
      "value": "Edit with Rovo in docs and pages"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.description": [
    {
      "type": 0,
      "value": "Save time by using summaries and audio briefings to get the context you need."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.title": [
    {
      "type": 0,
      "value": "Get information faster"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.features.title": [
    {
      "type": 0,
      "value": "Use Rovo in a number of ways:"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.hero.alt": [
    {
      "type": 0,
      "value": "Atlassian Intelligence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.rovo": [
    {
      "type": 0,
      "value": "Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle": [
    {
      "type": 0,
      "value": "Looks like you used "
    },
    {
      "type": 1,
      "value": "featureName"
    },
    {
      "type": 0,
      "value": " — here are more ways to use Rovo in Confluence."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome-rovo": [
    {
      "type": 0,
      "value": "Let's look at "
    },
    {
      "type": 1,
      "value": "rovo"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Get work done with Atlassian Intelligence"
    }
  ]
}